// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"48a07f6e","555":"288a90a0","741":"8f547d19","743":"ebedd5bd","806":"860f0786","895":"448f082e"}[chunkId] + ".chunk.css";
};